
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.64084 2.42262C7.415 1.33298 4.96738 2.37071 3.79379 2.98036C-0.101394 5.00383 0.0168521 10.1785 4.52417 11.1075C8.13975 11.8527 9.65376 7.91505 9.91568 4.95902C10.0222 3.75713 10.0621 2.39065 9.01267 1.57273C8.26012 0.986176 7.09234 0.719621 6.33019 1.41337C3.55211 3.94214 2.83088 10.3248 6.6489 12.2097C12.0936 14.8976 13.913 8.75759 13.0762 4.54736C13.0448 4.38903 12.1183 2.08864 12.1865 1.99767C12.4814 1.60441 15.2081 3.39209 15.4931 3.57794C16.2083 4.04434 16.9888 4.57392 15.8118 4.57392","stroke":"#DBEC1F","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    